import React from "react";

const BlankLayout = ({ children }) => {
  return <pre>{children}</pre>;
};

export default BlankLayout;
